import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const bugReportsApi = createApi({
  reducerPath: 'bugReportsApi',
  baseQuery: axiosFetchBase,
  tagTypes: ['BugReports'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getBugReports: builder.query({
      query: () => ({
        url: urls.bugReports,
      }),
      transformResponse: (response) => response?.data ?? [],
      providesTags: ['BugReports'],
    }),

    getBugReport: builder.query({
      query: (id) => ({
        url: urls.bugReportDetail(id),
      }),
      transformResponse: (response) => response?.data ?? null,
      providesTags: (result, error, id) => [{ type: 'BugReports', id }],
    }),

    setBugReportResolved: builder.mutation({
      query({ id, isResolved }) {
        return {
          url: urls.bugReportDetail(id),
          method: 'PUT',
          data: { is_resolved: isResolved },
        };
      },
      invalidatesTags: (result, error, { id }) => [
        'BugReports',
        { type: 'BugReports', id },
      ],
    }),
  }),
});

export const {
  useGetBugReportsQuery,
  useGetBugReportQuery,
  useSetBugReportResolvedMutation,
} = bugReportsApi;
